import { RESET,SET_STATUS, SET_TEAM, SET_CHALLENGE_STATUS, SET_CHALLENGES } from './actionTypes'
import { setState } from '../workoutTogether/actions'

function initialState( preserve = {} ) {
  return Object.assign({},{
    challenge: {},
    team: {},
    challenges : {},
    teams : {},
    challengesSorted : []
  }, preserve )
}

export default function (state = initialState(), action) {
  
  switch ( action.type ) {
    case SET_STATUS:
      if (!action.status || action.status.team==null || action.status.challenge==null) {
        console.log(action);
        state.team = { notFound :true }
        state.challenge.notFound= { notFound :true }
      } else {
        state.challenges[ action.status.challenge.id ] = action.status.challenge
        state.challenge =  action.status.challenge
  
        state.teams[ action.status.team.team_id ] = action.status.team
        state.team =  action.status.team

        state.challengesSorted = sortChallenges({ challenges:state.challenges })

      }


      
      break

    case SET_CHALLENGE_STATUS:
      state.challenges[ action.status.challenge.id ] = action.status.challenge
      state.challenge =  action.status.challenge
      state.challengesSorted = sortChallenges({ challenges:state.challenges })

      break;
    case SET_CHALLENGES:
      state.challenges = action.challenges
      state.challengesSorted = sortChallenges({ challenges:state.challenges })
      break;
    case SET_TEAM:
      state.teams[ action.team.team_id ] = action.team
      state.team =  action.team
      
      break
    
    case RESET:
      
      state = initialState()

      break
    
    default:
  
    }
    
    return state
}

function sortChallenges( options={} ) {
  var sortable=[]

  for (let [ id, challenge ] of Object.entries( options.challenges ) ) {
      sortable.push( challenge )
  }

  if ( sortable.length ) sortable.sort( (a,b) => (( a.name ).toLowerCase() > ( b.name ).toLowerCase() ? 1 : -1 ) )

  return sortable
}